/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  parentForm: Object,
  model: Object,
  resetModels: Array,
  resetFields: Array,
  fields: ?Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewCompanySuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, parentForm, model, fields }: TypeProps = this.props;

    //Set Selected Trading Account
    if (fields.account) {
      parentForm.$(`${fields.account}`).extra.selectID = actionDrawerStore.response.account_id;
    }

    if (fields.company) {
      const field = parentForm.$(`${fields.company}`);
      const fieldExtra = field.extra;

      field.set('value', actionDrawerStore.response.name);
      field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
      model.filterId = actionDrawerStore.response.account_id;
      model.parentId = actionDrawerStore.response.account_id;
      model.search = '';
      model.loadData();
    }

    this.props.onMountHook();

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
